import jwtDecode from 'jwt-decode';

export const CATALOG_TOKENS_KEY = '&catalog-tokens';
export const CATALOG_LIST_KEY = '&usuario-catalog-list';

const EXPIRY_BUFFER_MS = 60 * 1000;

export function isTokenValid(token) {
    if (!token) {
        return false;
    }
    try {
        const decoded = jwtDecode(token);
        if (!decoded.exp) {
            return false;
        }
        return decoded.exp * 1000 > Date.now() + EXPIRY_BUFFER_MS;
    } catch {
        return false;
    }
}

function readCache() {
    try {
        return JSON.parse(localStorage.getItem(CATALOG_TOKENS_KEY) || '{}');
    } catch {
        return {};
    }
}

function writeCache(cache) {
    localStorage.setItem(CATALOG_TOKENS_KEY, JSON.stringify(cache));
}

export function pruneExpiredCatalogTokens() {
    const cache = readCache();
    let changed = false;

    Object.keys(cache).forEach((catalogName) => {
        const entry = cache[catalogName];
        if (!entry?.token || !isTokenValid(entry.token)) {
            delete cache[catalogName];
            changed = true;
        }
    });

    if (changed) {
        writeCache(cache);
    }
}

export function getCachedCatalogSession(catalogName) {
    if (!catalogName) {
        return null;
    }

    pruneExpiredCatalogTokens();

    const entry = readCache()[catalogName];
    if (!entry?.token || !isTokenValid(entry.token)) {
        return null;
    }

    try {
        const decoded = jwtDecode(entry.token);
        const tokenCatalog = decoded?.user?.catalogName;
        if (tokenCatalog && tokenCatalog !== catalogName) {
            return null;
        }
    } catch {
        return null;
    }

    return entry;
}

export function setCachedCatalogSession(catalogName, { token, id, nome, email }) {
    if (!catalogName || !token) {
        return;
    }

    const cache = readCache();
    cache[catalogName] = {
        token,
        id: id ?? cache[catalogName]?.id ?? null,
        nome: nome ?? cache[catalogName]?.nome ?? null,
        email: email ?? cache[catalogName]?.email ?? null
    };
    writeCache(cache);
}

export function removeCachedCatalogSession(catalogName) {
    if (!catalogName) {
        return;
    }
    const cache = readCache();
    if (cache[catalogName]) {
        delete cache[catalogName];
        writeCache(cache);
    }
}

export function getCachedCatalogListData() {
    try {
        const raw = localStorage.getItem(CATALOG_LIST_KEY);
        if (!raw) {
            return null;
        }
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function setCachedCatalogListData(data) {
    if (!data) {
        return;
    }
    localStorage.setItem(CATALOG_LIST_KEY, JSON.stringify(data));
}

export function clearCachedCatalogListData() {
    localStorage.removeItem(CATALOG_LIST_KEY);
}
